import { makeStyles } from 'tss-react/mui';

const useStylesMenuItemNested: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  menuItem: {
    backgroundColor: theme.palette.action.hover,
  },
}));

export default useStylesMenuItemNested;
